import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["aside"];

  toggle(){
    this.asideTarget.classList.toggle("is-block");
  }
}
